import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';

import CN from './ColumnOrderSuccessModal.module.scss';

const ColumnOrderSuccessModal = ({ onClick }) => (
  <SalonModal tag="ColumnOrderSuccessModal" isOpen variant="noFooter">
    <SalonModal.Header>
      <div className={CN.closeButtonContainer}>
        <Button variant="empty" onClick={onClick}>
          <Icon variant="close" variantInvert />
        </Button>
      </div>
    </SalonModal.Header>
    <SalonModal.Body>
      <div className={CN.image}>
        <IconStatus variant="alert">
          <Icon variant="alert" />
        </IconStatus>
      </div>
      <div className={CN.content}>
        <div className={CN.title}>Refresh required</div>
        <span className={CN.text}>
          You have moved a staff column. Please hit the refresh button on your browser to see your updated order of
          columns.
        </span>
      </div>
    </SalonModal.Body>
  </SalonModal>
);

export default ColumnOrderSuccessModal;
